import React from 'react';
import { motion } from 'framer-motion';
import { Language } from '../App';
import { PageHero } from '../components/PageHero';
interface TeamProps {
  language: Language;
}
interface TeamMember {
  nameEn: string;
  namePs: string;
  roleEn: string;
  rolePs: string;
  image?: string;
}
export function Team({
  language
}: TeamProps) {
  const isPashto = language === 'pashto';
  const groups: {
    titleEn: string;
    titlePs: string;
    members: TeamMember[];
  }[] = [{
    titleEn: 'Leadership',
    titlePs: 'مشرتابه',
    members: [{
      nameEn: 'Dr. Israr',
      namePs: 'ډاکټر اسرار',
      roleEn: 'Patron',
      rolePs: 'نګران',
      image: 'https://cdn.magicpatterns.com/uploads/jSqpbF5sdq9ANE6SEBsadD/WhatsApp_Image_2026-05-02_at_5.43.04_PM_(4).jpg'
    }, {
      nameEn: 'Hazrat Zubair Zubair',
      namePs: 'حضرت زبېر زبېر',
      roleEn: 'Editor',
      rolePs: 'ترتیب کوونکی',
      image: 'https://cdn.magicpatterns.com/uploads/2y7E4qH2yradnpNCoDtKAG/WhatsApp_Image_2026-05-02_at_5.43.04_PM_(1).jpg'
    }]
  }, {
    titleEn: 'Advisory Board',
    titlePs: 'مشاورتی بورډ',
    members: [{
      nameEn: 'M. R. Shafaq',
      namePs: 'م ر شفق',
      roleEn: 'Advisory Board',
      rolePs: 'مشاورتی بورډ',
      image: 'https://cdn.magicpatterns.com/uploads/fi5huWRdRVC9ZZtcbroLCf/WhatsApp_Image_2026-05-02_at_5.43.04_PM_(2).jpg'
    }, {
      nameEn: 'Rahmat Shah Sail',
      namePs: 'رحمت شاه سائل',
      roleEn: 'Advisory Board',
      rolePs: 'مشاورتی بورډ',
      image: 'https://cdn.magicpatterns.com/uploads/dwHjWNJEPPqdiMBPyn2dsy/WhatsApp_Image_2026-05-02_at_5.43.04_PM.jpg'
    }, {
      nameEn: 'Gul Muhammad Bētāb',
      namePs: 'ګل محمد بېتاب',
      roleEn: 'Advisory Board',
      rolePs: 'مشاورتی بورډ',
      image: 'https://cdn.magicpatterns.com/uploads/wnA18WsDUsjhdUjEmdSZh7/WhatsApp_Image_2026-05-02_at_5.43.04_PM_(3).jpg'
    }]
  }, {
    titleEn: 'Legal Advisor',
    titlePs: 'قانونی مشیر',
    members: [{
      nameEn: 'Akbar Hoti Advocate',
      namePs: 'اکبر هوتی اېډوکېټ',
      roleEn: 'Legal Advisor',
      rolePs: 'قانونی مشیر',
      image: 'https://cdn.magicpatterns.com/uploads/vnriwUjtdR5xyBA7Yhaihd/WhatsApp_Image_2026-05-02_at_5.54.33_PM_(2).jpg'
    }]
  }, {
    titleEn: 'Associate Editors',
    titlePs: 'مرستیال ملګري',
    members: [{
      nameEn: 'Muhammad Usman Mardanwi',
      namePs: 'محمد عثمان مردانوی',
      roleEn: 'Associate Editor',
      rolePs: 'مرستیال ملګری',
      image: 'https://cdn.magicpatterns.com/uploads/uQNHGEsRPYiZ4MLodgVr3z/WhatsApp_Image_2026-05-02_at_5.54.33_PM.jpg'
    }, {
      nameEn: 'Ijaz Afghani',
      namePs: 'اعجاز افغاني',
      roleEn: 'Associate Editor',
      rolePs: 'مرستیال ملګری',
      image: 'https://cdn.magicpatterns.com/uploads/xbrU1L3et6yzYgDPPJ3Fgz/WhatsApp_Image_2026-05-02_at_5.54.33_PM_(4).jpg'
    }, {
      nameEn: 'Syed Afzal Shah',
      namePs: 'سید افضل شاه',
      roleEn: 'Associate Editor',
      rolePs: 'مرستیال ملګری',
      image: 'https://cdn.magicpatterns.com/uploads/jrGMm1Dj1ycuFtcDYYfB93/WhatsApp_Image_2026-05-02_at_6.13.27_PM_(2).jpg'
    }, {
      nameEn: 'Dr. Muhammad Owais Qarni',
      namePs: 'ډاکټر محمد اوېس قرني',
      roleEn: 'Associate Editor',
      rolePs: 'مرستیال ملګری',
      image: 'https://cdn.magicpatterns.com/uploads/kYrDHZLU32YsFUvCqyVrMg/WhatsApp_Image_2026-05-02_at_6.13.27_PM_(1).jpg'
    }, {
      nameEn: 'Inam Shah Inam',
      namePs: 'انعام شاه انعام',
      roleEn: 'Associate Editor',
      rolePs: 'مرستیال ملګری',
      image: 'https://cdn.magicpatterns.com/uploads/cpFZM2zBaMMcaF4ZVSNDtp/WhatsApp_Image_2026-05-02_at_5.54.33_PM_(5).jpg'
    }]
  }, {
    titleEn: 'Operations',
    titlePs: 'چارې',
    members: [{
      nameEn: 'Hazrat Gul',
      namePs: 'حضرت ګل',
      roleEn: 'Student Liaison',
      rolePs: 'د طالب علمانو سره رابطه کوونکی',
      image: 'https://cdn.magicpatterns.com/uploads/bAPfRkZSBzyQ4Z5DWq6yjH/WhatsApp_Image_2026-05-02_at_6.13.27_PM.jpg'
    }, {
      nameEn: 'Hameed Hatif',
      namePs: 'حميد هاتف',
      roleEn: 'Proof-reader',
      rolePs: 'د املا تصحیح کوونکی'
    }, {
      nameEn: 'Syed Muhammad Ali',
      namePs: 'سید محمد علي',
      roleEn: 'Print Manager',
      rolePs: 'د چاپ منتظم',
      image: 'https://cdn.magicpatterns.com/uploads/wtdV5UjvN5VoJob5gCoUKS/WhatsApp_Image_2026-05-02_at_5.54.33_PM_(3).jpg'
    }, {
      nameEn: 'Azhar Khattak',
      namePs: 'اظهر خټک',
      roleEn: 'Distribution Lead',
      rolePs: 'د مجلې د خپرونې مسؤل'
    }]
  }];
  return <div className="pt-24 md:pt-28 bg-gray-50 min-h-screen pb-12" data-id="element-660">
      <PageHero language={language} titleEn="The Team" titlePs="زموږ ټیم" introEn="Meet the dedicated editors, advisors and contributors behind Pasoon magazine." introPs="د پاڅون مجلې تر شا د وقف شویو مدیرانو، مشاورینو او ملګرو سره وپیژنئ." data-id="element-661" />

      <div className="max-w-6xl mx-auto px-6" data-id="element-662">
        {groups.map((group, gIdx) => <section key={gIdx} className="py-8 md:py-10" data-id="element-663">
            {/* Group Heading */}
            <div className="mb-8 text-start" data-id="element-664">
              <h2 className={`text-2xl md:text-3xl font-bold text-pasoon-dark inline-block relative ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-665">
                {isPashto ? group.titlePs : group.titleEn}
                <span className="absolute -bottom-2 start-0 w-1/2 h-1 bg-pasoon-red rounded-full" data-id="element-666"></span>
              </h2>
            </div>

            {/* Members Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-667">
              {group.members.map((member, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.08,
            duration: 0.4
          }} className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-668">
                  {/* Image / Initials */}
                  <div className="h-56 bg-gradient-to-b from-pasoon-red/5 to-pasoon-red/10 flex items-center justify-center overflow-hidden" data-id="element-669">
                    {member.image ? <img src={member.image} alt={isPashto ? member.namePs : member.nameEn} className="w-full h-full object-cover" data-id="element-670" /> : <div className="w-24 h-24 rounded-full bg-pasoon-red/20 border-4 border-white flex items-center justify-center text-pasoon-red text-3xl font-bold" data-id="element-671">
                        {isPashto ? member.namePs.charAt(0) : member.nameEn.charAt(0)}
                      </div>}
                  </div>

                  {/* Details */}
                  <div className="p-5 text-center" data-id="element-672">
                    <h3 className={`text-lg font-bold text-pasoon-dark mb-1 ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-673">
                      {isPashto ? member.namePs : member.nameEn}
                    </h3>
                    <p className={`text-pasoon-red font-medium text-sm ${isPashto ? 'font-pashto' : ''}`} data-id="element-674">
                      {isPashto ? member.rolePs : member.roleEn}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </section>)}
      </div>
    </div>;
}